import Select from '@cube3/cubicle/src/core/atoms/Select/Select';
import { Option } from '@cube3/cubicle/src/core/atoms/Select/Option';
import React, { useCallback, useMemo } from 'react';
import { useGenerativeContext } from '../contexts/GenerativeContext';
import { Thumbnail } from '@cube3/cubicle/src/core/atoms/Thumbnail/Thumbnail';
import { Tooltip } from '@cube3/cubicle/src/core/atoms/Tooltip/Tooltip';
import { SizeVariants } from '@cube3/cubicle/src/theme/themes';
import { HBox } from '@cube3/cubicle/src/core/templates/layout/Flex';
import { Divider } from '@cube3/cubicle/src/core/atoms/Divider/Divider';
import { TreeNode } from '@cube3/cubicle/src/core/atoms/TreeNode';
import { buildGenerationTree } from '../utils/buildGenerationTree';

export const GenerationHistory = () => {
  const { generations, setActiveGeneration } = useGenerativeContext();

  const onClick = useCallback((value) => () => setActiveGeneration(value), []);

  const getItem = useCallback(
    (id: string) => generations?.find((g) => g.id === id),
    [generations]
  );

  const generationTree = useMemo(
    () => buildGenerationTree(generations),
    [generations]
  );

  if (!generations?.length) return null;

  return (
    <Select
      value=""
      width={28} // 112px
      placeholder="History"
      hideSelectedValue={true}
      dropDownWidth={96}
      anchorPlacement="top-start"
    >
      {Object.entries(generationTree).map(([rootId, branches], idx) => {
        const root = getItem(rootId);
        {
          /* level 1 */
        }
        return (
          <div key={'root_' + idx + rootId}>
            <HistoryItem item={root} onClick={onClick} isRoot={true} />

            <TreeNode nodeHeight={40}>
              {Object.entries(branches).map(([parentId, children], i) => {
                const parent = getItem(parentId);
                {
                  /* level 2 */
                }
                return (
                  <div key={'parent_' + i + parentId}>
                    <HistoryItem
                      key={parent.id}
                      item={parent}
                      onClick={onClick}
                    />
                    {/* level 3 */}
                    <TreeNode marginLeft={48} nodeHeight={40}>
                      {children.map((c, x) => (
                        <HistoryItem key={c + x} item={c} onClick={onClick} />
                      ))}
                    </TreeNode>
                  </div>
                );
              })}
            </TreeNode>
          </div>
        );
      })}
    </Select>
  );
};

const HistoryItem = (props) => {
  const { item, onClick, isRoot } = props;

  return (
    <HBox align="center">
      {isRoot ? null : <Divider length={16} />}
      <div style={{ width: isRoot ? '100%' : 'calc(100% - 16px)' }}>
        <Option
          value={item.prompt}
          onClick={onClick(item)}
          active={item.active}
          startAdornment={
            <Tooltip
              content={<Thumbnail src={item.url} size={SizeVariants.lg} />}
              placement="left"
            >
              <Thumbnail src={item.url} size={SizeVariants.sm} />
            </Tooltip>
          }
        />
      </div>
    </HBox>
  );
};
